import { render, staticRenderFns } from "./IsStayRestricted.vue?vue&type=template&id=53736b1d&"
import script from "./IsStayRestricted.vue?vue&type=script&lang=js&"
export * from "./IsStayRestricted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53736b1d')) {
      api.createRecord('53736b1d', component.options)
    } else {
      api.reload('53736b1d', component.options)
    }
    module.hot.accept("./IsStayRestricted.vue?vue&type=template&id=53736b1d&", function () {
      api.rerender('53736b1d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/inputs/IsStayRestricted.vue"
export default component.exports